//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'RequestWorkTypeStatusCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    workType: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      valueLocal: this.value
    }
  },
  computed: {
    status: function () {
      if (!this.workType.hasDoneReports) {
        return 'notDone'
      }
      if (this.workType.hasDoneReports && this.workType.inclusionMode === 'stopped') {
        return 'done'
      }
      if (this.workType.hasDoneReports && this.workType.inclusionMode !== 'stopped') {
        return 'doneAndWillBeRepeated'
      }
      return null
    },
    color: function () {
      switch (this.status) {
        case 'notDone':
          return 'primary'
        case 'done':
        case 'doneAndWillBeRepeated':
          return 'grey'
        default:
          return ''
      }
    },
    classNames: function () {
      switch (this.status) {
        case 'doneAndWillBeRepeated':
          return 'border-primary'
        default:
          return ''
      }
    },
    tooltipText: function () {
      switch (this.status) {
        case 'notDone':
          return 'Работа не выполнена'
        case 'done':
          return 'Работа выполнена'
        case 'doneAndWillBeRepeated':
          return 'Работа выполнена. Выполнение работ будет продолжено при назначении дополнительного выезда'
        default:
          return ''
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.valueLocal = newVal
    }
  },
  methods: {
    onInputValue: function (value) {
      this.valueLocal = value
      this.$emit('input', value)
    }
  }
}

